/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AxiosError } from 'axios';
import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import {
  DriverPoints,
  DriverVehicleSeriesDataResponse,
  EventDriverNameVehicleNumber,
  VehicleOemListResponse,
} from 'models/viewModels';

class DriverApi {
  async getDrivers(seriesId: string, eventId?: string, season?: number): Promise<DriverVehicleSeriesDataResponse> {
    const params = {
      seriesId: parseInt(seriesId),
      eventId: parseInt(eventId || '0'),
      season,
    };
    return new Promise<DriverVehicleSeriesDataResponse>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/team/getDriverVehicleSeriesData', { params })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }

  async getDriversByEventGroupId(eventGroupId: string): Promise<DriverVehicleSeriesDataResponse> {
    return new Promise<DriverVehicleSeriesDataResponse>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/team/getDriverVehicleSeriesData', { params: { eventGroupId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }

  async getPlayoffDrivers(seriesId: string, season: number, raceId?: string): Promise<DriverPoints[]> {
    const params = {
      seriesId: parseInt(seriesId),
      raceId: parseInt(raceId || '0'),
      season,
    };
    return new Promise<DriverPoints[]>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/team/playoffDrivers', { params })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }

  async getDriversByEventId(eventId: string): Promise<EventDriverNameVehicleNumber[]> {
    return new Promise<EventDriverNameVehicleNumber[]>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/nascar/api/getDriverNamesByEventId', { params: { eventId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }

  async getVehicleOemList(seriesId: string): Promise<VehicleOemListResponse> {
    return new Promise<VehicleOemListResponse>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/team/getVehicleOemList', { params: { seriesId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }

  async getDistinctSeriesVehicles(seriesId: number): Promise<DriverVehicleSeriesDataResponse> {
    return new Promise<DriverVehicleSeriesDataResponse>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/team/getDriverVehicleSeriesData', { params: { seriesId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }
}

export const driverApi = new DriverApi();
